module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epigraphpage"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("So holy and so perfect is my love,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("And I in such a poverty of grace,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("That I shall think it a most plenteous crop")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("To glean the broken ears after the man")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("That the main harvest reaps. Loose now and then")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("A scattered smile, and that I’ll live upon.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("As You Like It")]), _vm._v(", III. 5")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("I sang the way I still talk. Every song was the worst way I could think of to ask for what I did not yet know how not to want.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("—Gary Lutz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stories in the Worst Way")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b07f731","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004epigraphpage.vue
// module id = 66
// module chunks = 0